// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
    background-size: cover; /* Ensures the image covers the entire viewport */
    background-position: center; /* Centers the image */
    background-repeat: no-repeat; /* Prevents the image from repeating */
    background-attachment: fixed; /* Makes the background stay in place when scrolling */
}

.gameOption {
    height: 3rem;
    width: 3rem;
    background-size: 80%;
    background-repeat: no-repeat;
    background-position: 50%;
    border-radius: 0.2rem;
    border: 1px solid white !important;
}

.login-with-steam{
    font-size: 2.5em;
    font-weight: bold;
    text-decoration: none;
    padding: 0 0.5em 0 0.5em;
}

.item-grid-bar{
    background-color: #16161d;
    background-clip: content-box;
    height: 4em;
    width: 45%;
    border: 0.2rem solid rgb(90, 90, 90);
}

.item-carousel-container{
    width: 45%;
}

.item-carousel-container .itemValue{
    font-size: 2em;
    width: 8em;
    font-family: 'Milonga', serif;
    -webkit-user-select: none;
            user-select: none;  /* Prevent image selection */
    -webkit-user-drag: none; /* Prevent dragging in Webkit browsers */
    outline: none; /* Remove blue outline on focus */
    background: #16161d;
    border: 0.2rem solid rgb(90, 90, 90);
}

.item-filter-btn{
    font-size: 1.5em;
    font-family: 'Ubuntu Mono';
}

.glass{
    /* From https://css.glass */
    background: rgba(255, 255, 255, 0.274);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.3);
}

.tradeBtn {
    font-family: 'Milonga', serif;
    background: linear-gradient(to left, rgb(0, 186, 114) 50%, #006507  50%);
    background-size: 200%;
    background-position: left;
    transition: background-position 0.5s ease-out;
    transition: 0.15s all ease;
    transform: scale(1);
    font-size: 2em;
    color: black; /* Adjust text color for visibility */
    border: none; /* Optional: Remove border if needed */
}

.tradeBtn:hover {
    transform: scale(1.2);
    background-position: right;
    box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset, 
                rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset, 
                rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, 
                rgba(0, 0, 0, 0.06) 0px 2px 1px, 
                rgba(0, 0, 0, 0.09) 0px 4px 2px, 
                rgba(0, 0, 0, 0.09) 0px 8px 4px, 
                rgba(0, 0, 0, 0.09) 0px 16px 8px, 
                rgba(0, 0, 0, 0.09) 0px 32px 16px;
}

.loading-message {
    font-family: 'Milonga', serif;
    color: #ffc200 !important;
    font-size: 2.5em;
}

#price-difference{
    color: #ffc200 !important;
    font-family: 'Milonga', serif;
    -webkit-user-select: none;
            user-select: none;  /* Prevent image selection */
    -webkit-user-drag: none; /* Prevent dragging in Webkit browsers */
    outline: none; /* Remove blue outline on focus */
}

.alert-fixed-top{
    position:fixed; 
    top: 5em;     
    left: 50%;
    transform: translateX(-50%); 
    width: 50%;
    z-index:9999;
}

.gameSelector {
    border-top: 0.2rem solid rgb(90, 90, 90);
    border-left: 0.2rem solid rgb(90, 90, 90);
    border-right: 0.2rem solid rgb(90, 90, 90);
    width: 10rem;
    height: 4rem;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
}

.itemGrid {
    height: 30rem !important;
    gap: 0.2em;
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;
    overflow-y: scroll;
    overflow-x: hidden;
    position: relative;
    background-color: transparent;
}

.itemGrid {
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
}
.itemGrid::-webkit-scrollbar { 
    display: none;  /* Safari and Chrome */
}

.item-search-form{
    display: flex;
    align-items: center;
}

.item-search-form input::placeholder{
    color: white;
    font-family: 'Milonga', serif;
    font-size: 1.5rem;
}

.inventory-container{
    width: 45%;
}
.item-search-form i{
    height: 100%;
    border-bottom: 0.2rem solid #ffc200;
    font-size: 2rem; 
}

.item-search-form input{
    border: none !important;
    font-size: 1.5rem;
    width: 10em;
    background-color: #383847;
}

.item-search-form input:focus{
    background-color: #383847;
    outline: 2px solid white !important;
}

.item-search-form input:focus + i{
    background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Trade.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB,EAAE,iDAAiD;IACzE,2BAA2B,EAAE,sBAAsB;IACnD,4BAA4B,EAAE,sCAAsC;IACpE,4BAA4B,EAAE,sDAAsD;AACxF;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,4BAA4B;IAC5B,wBAAwB;IACxB,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,WAAW;IACX,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;IACV,6BAA6B;IAC7B,yBAAiB;YAAjB,iBAAiB,GAAG,4BAA4B;IAChD,uBAAuB,EAAE,wCAAwC;IACjE,aAAa,EAAE,iCAAiC;IAChD,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;IACtC,yCAAyC;IACzC,0BAA0B;IAC1B,kCAAkC;IAClC,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;IAC7B,wEAAwE;IACxE,qBAAqB;IACrB,yBAAyB;IACzB,6CAA6C;IAC7C,0BAA0B;IAC1B,mBAAmB;IACnB,cAAc;IACd,YAAY,EAAE,qCAAqC;IACnD,YAAY,EAAE,sCAAsC;AACxD;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B;;;;;;;iDAO6C;AACjD;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,yBAAiB;YAAjB,iBAAiB,GAAG,4BAA4B;IAChD,uBAAuB,EAAE,wCAAwC;IACjE,aAAa,EAAE,iCAAiC;AACpD;;AAEA;IACI,cAAc;IACd,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,wCAAwC;IACxC,yCAAyC;IACzC,0CAA0C;IAC1C,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;IACxB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,wBAAwB,GAAG,0BAA0B;IACrD,qBAAqB,GAAG,YAAY;AACxC;AACA;IACI,aAAa,GAAG,sBAAsB;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;AACA;IACI,YAAY;IACZ,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":["body{\n    background-size: cover; /* Ensures the image covers the entire viewport */\n    background-position: center; /* Centers the image */\n    background-repeat: no-repeat; /* Prevents the image from repeating */\n    background-attachment: fixed; /* Makes the background stay in place when scrolling */\n}\n\n.gameOption {\n    height: 3rem;\n    width: 3rem;\n    background-size: 80%;\n    background-repeat: no-repeat;\n    background-position: 50%;\n    border-radius: 0.2rem;\n    border: 1px solid white !important;\n}\n\n.login-with-steam{\n    font-size: 2.5em;\n    font-weight: bold;\n    text-decoration: none;\n    padding: 0 0.5em 0 0.5em;\n}\n\n.item-grid-bar{\n    background-color: #16161d;\n    background-clip: content-box;\n    height: 4em;\n    width: 45%;\n    border: 0.2rem solid rgb(90, 90, 90);\n}\n\n.item-carousel-container{\n    width: 45%;\n}\n\n.item-carousel-container .itemValue{\n    font-size: 2em;\n    width: 8em;\n    font-family: 'Milonga', serif;\n    user-select: none;  /* Prevent image selection */\n    -webkit-user-drag: none; /* Prevent dragging in Webkit browsers */\n    outline: none; /* Remove blue outline on focus */\n    background: #16161d;\n    border: 0.2rem solid rgb(90, 90, 90);\n}\n\n.item-filter-btn{\n    font-size: 1.5em;\n    font-family: 'Ubuntu Mono';\n}\n\n.glass{\n    /* From https://css.glass */\n    background: rgba(255, 255, 255, 0.274);\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.tradeBtn {\n    font-family: 'Milonga', serif;\n    background: linear-gradient(to left, rgb(0, 186, 114) 50%, #006507  50%);\n    background-size: 200%;\n    background-position: left;\n    transition: background-position 0.5s ease-out;\n    transition: 0.15s all ease;\n    transform: scale(1);\n    font-size: 2em;\n    color: black; /* Adjust text color for visibility */\n    border: none; /* Optional: Remove border if needed */\n}\n\n.tradeBtn:hover {\n    transform: scale(1.2);\n    background-position: right;\n    box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset, \n                rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset, \n                rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, \n                rgba(0, 0, 0, 0.06) 0px 2px 1px, \n                rgba(0, 0, 0, 0.09) 0px 4px 2px, \n                rgba(0, 0, 0, 0.09) 0px 8px 4px, \n                rgba(0, 0, 0, 0.09) 0px 16px 8px, \n                rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n.loading-message {\n    font-family: 'Milonga', serif;\n    color: #ffc200 !important;\n    font-size: 2.5em;\n}\n\n#price-difference{\n    color: #ffc200 !important;\n    font-family: 'Milonga', serif;\n    user-select: none;  /* Prevent image selection */\n    -webkit-user-drag: none; /* Prevent dragging in Webkit browsers */\n    outline: none; /* Remove blue outline on focus */\n}\n\n.alert-fixed-top{\n    position:fixed; \n    top: 5em;     \n    left: 50%;\n    transform: translateX(-50%); \n    width: 50%;\n    z-index:9999;\n}\n\n.gameSelector {\n    border-top: 0.2rem solid rgb(90, 90, 90);\n    border-left: 0.2rem solid rgb(90, 90, 90);\n    border-right: 0.2rem solid rgb(90, 90, 90);\n    width: 10rem;\n    height: 4rem;\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n}\n\n.itemGrid {\n    height: 30rem !important;\n    gap: 0.2em;\n    display: flex;\n    flex-flow: row wrap;\n    align-content: flex-start;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    position: relative;\n    background-color: transparent;\n}\n\n.itemGrid {\n    -ms-overflow-style: none;  /* Internet Explorer 10+ */\n    scrollbar-width: none;  /* Firefox */\n}\n.itemGrid::-webkit-scrollbar { \n    display: none;  /* Safari and Chrome */\n}\n\n.item-search-form{\n    display: flex;\n    align-items: center;\n}\n\n.item-search-form input::placeholder{\n    color: white;\n    font-family: 'Milonga', serif;\n    font-size: 1.5rem;\n}\n\n.inventory-container{\n    width: 45%;\n}\n.item-search-form i{\n    height: 100%;\n    border-bottom: 0.2rem solid #ffc200;\n    font-size: 2rem; \n}\n\n.item-search-form input{\n    border: none !important;\n    font-size: 1.5rem;\n    width: 10em;\n    background-color: #383847;\n}\n\n.item-search-form input:focus{\n    background-color: #383847;\n    outline: 2px solid white !important;\n}\n\n.item-search-form input:focus + i{\n    background-color: transparent;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
